import { FaMagnifyingGlass } from "react-icons/fa6";

const TitleRecordFunction = ({ addRecordMessage, deleteRecordMessage, title, isViewRecord }) => {
    if (isViewRecord) {
        return <h2 className='title_view_record'>{title} <FaMagnifyingGlass /></h2>
    }
    if (addRecordMessage) {
        return <h2 className='title_view_record'>{addRecordMessage}</h2>
    }
    if (deleteRecordMessage) {
        return <h2 className='title_view_record'>{deleteRecordMessage}</h2>
    }
}
export default TitleRecordFunction;